import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { Layers, Inbox, FileEdit, Share2, Users } from 'lucide-react';

// Left-side navigation for the Action Cards section.
// All Cards · My Cards (→ Drafts sub-item) · Shared · Team.
// Route-driven so it renders identically on /action-cards, /drafts and /shared.
export function CardsSideNav({ onNavigate }) {
  const { pathname } = useLocation();
  const [sp] = useSearchParams();
  const scope = sp.get('scope');

  const active =
    pathname === '/drafts' ? 'drafts'
    : pathname === '/shared' ? 'shared'
    : pathname.startsWith('/action-cards') ? (scope === 'personal' ? 'personal' : scope === 'team' ? 'team' : 'all')
    : '';

  const Item = ({ id, to, icon: Icon, label, sub }) => (
    <Link
      to={to}
      data-testid={`cards-nav-${id}`}
      onClick={() => onNavigate?.(id)}
      className={`fr-item fr-top${sub ? ' fr-sub' : ''}${active === id ? ' active' : ''}`}
      style={{ textDecoration: 'none' }}
    >
      {sub && <span className="fr-caret" />}
      <Icon size={sub ? 13 : 14} />
      <span className="fr-label-plain">{label}</span>
    </Link>
  );

  return (
    <div data-testid="cards-side-nav">
      <Item id="all" to="/action-cards" icon={Layers} label="All Cards" />
      <Item id="personal" to="/action-cards?scope=personal" icon={Inbox} label="My Cards" />
      <Item id="drafts" to="/drafts" icon={FileEdit} label="Drafts" sub />
      <Item id="shared" to="/shared" icon={Share2} label="Shared" />
      <Item id="team" to="/action-cards?scope=team" icon={Users} label="Team" />
    </div>
  );
}
